var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'action-container': true,
    disabled: _vm.disabled,
    primary: _vm.primary,
  },on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }